import { render } from "./footer.vue?vue&type=template&id=75d47631"
const script = {}

import exportComponent from "D:\\eihs-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__